import { render, staticRenderFns } from "./NdviChartHc.vue?vue&type=template&id=7c59e072&"
import script from "./NdviChartHc.vue?vue&type=script&lang=ts&"
export * from "./NdviChartHc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports